// Suivi d'audience first-party (sans cookie publicitaire).
// Gère l'identifiant visiteur (localStorage, persistant) et l'identifiant de
// session (sessionStorage, réinitialisé après 30 min d'inactivité), l'envoi des
// vues/envois de formulaires et la durée passée sur chaque page.
import { api } from "@/lib/api";

const VID_KEY = "prx_vid";
const SID_KEY = "prx_sid";
const SID_TS = "prx_sid_ts";
const MAX_IDLE = 30 * 60 * 1000; // 30 minutes

function uuid() {
  return window.crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(36).slice(2);
}

export function getVisitorId() {
  try {
    let vid = localStorage.getItem(VID_KEY);
    if (!vid) {
      vid = uuid();
      localStorage.setItem(VID_KEY, vid);
    }
    return vid;
  } catch {
    return "";
  }
}

export function getSessionId() {
  try {
    const now = Date.now();
    let sid = sessionStorage.getItem(SID_KEY);
    const ts = Number(sessionStorage.getItem(SID_TS) || 0);
    if (!sid || now - ts > MAX_IDLE) {
      sid = uuid();
      sessionStorage.setItem(SID_KEY, sid);
    }
    sessionStorage.setItem(SID_TS, String(now));
    return sid;
  } catch {
    return "";
  }
}

export function trackEvent(type, form) {
  try {
    api.post("/track/event", {
      type,
      form: form || "",
      session_id: getSessionId(),
      visitor_id: getVisitorId(),
      path: window.location.pathname,
    }).catch(() => {});
  } catch {
    /* noop */
  }
}

export function trackFormView(form) {
  trackEvent("form_view", form);
}

export function trackFormSubmit(form) {
  trackEvent("form_submit", form);
}

// Envoie la durée passée sur une page (fiable même au moment où l'onglet se ferme).
export function sendDuration(path, ms) {
  try {
    if (!path || ms < 1000) return; // ignore les durées négligeables
    const body = JSON.stringify({ session_id: getSessionId(), path, duration_ms: Math.round(ms) });
    const url = (process.env.REACT_APP_BACKEND_URL || "") + "/api/track/duration";
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
    }
  } catch {
    /* noop */
  }
}
